export default {
  "states": {
    "created": "Não solicitado",
    "pending": "Pendente",
    "edited": "Editado",
    "accepted": "Aceitaram",
    "rejected": "Rejeitado"
  },
  "months": {
    "january": "janeiro",
    "february": "fevereiro",
    "march": "março",
    "april": "abril",
    "may": "maio",
    "june": "junho",
    "july": "julho",
    "august": "agosto",
    "september": "setembro",
    "october": "outubro",
    "november": "novembro",
    "dicember": "dezembro"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/flows/index.js